/**
 * @generated SignedSource<<408c0d503dc60185baeb5070b1098742>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteEmailTemplateDialog_emailTemplate$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "DeleteEmailTemplateDialog_emailTemplate";
};
export type DeleteEmailTemplateDialog_emailTemplate$key = {
  readonly " $data"?: DeleteEmailTemplateDialog_emailTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteEmailTemplateDialog_emailTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteEmailTemplateDialog_emailTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "EmailTemplate",
  "abstractKey": null
};

(node as any).hash = "ef3bed627eabef64a41a2e5180d747e9";

export default node;
